import { useEffect, useRef } from 'react';

import { useIntersectionObserver } from '../utils/useIntersectionObserver';

const HALF_VISIBLE_THRESHOLD = 0.5;

export const useTrackCpdDealsShow = (track: () => void) => {
  const ref = useRef<HTMLDivElement>(null);
  const hasTrackedRef = useRef(false);
  const entry = useIntersectionObserver(ref, {
    threshold: HALF_VISIBLE_THRESHOLD,
    freezeOnceVisible: true,
  });

  useEffect(() => {
    if (!entry?.isIntersecting || hasTrackedRef.current) {
      return;
    }

    hasTrackedRef.current = true;
    track();
  }, [entry, track]);

  return ref;
};
